import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        Sidebar_drawer: null,
        Customizer_drawer: false,
        SidebarColor: 'white',
        SidebarBg: '',
        navbarColor: "primary",
        setHorizontalLayout: true, // Horizontal layout
    },
    mutations: {
        SET_SIDEBAR_DRAWER(state, payload) {
            state.Sidebar_drawer = payload
        },
        SET_CUSTOMIZER_DRAWER(state, payload) {
            state.Customizer_drawer = payload
        },
        SET_SIDEBAR_COLOR(state, payload) {
            state.SidebarColor = payload
        },
        SET_NAVBAR_COLOR(state, payload) {
          state.navbarColor = payload;
        },
        SET_LAYOUT(state, payload) {
          state.setHorizontalLayout = payload;
        },
    },
    actions: {
    },
    getters: {
    }
})